import { render, staticRenderFns } from "./QAdetail.vue?vue&type=template&id=ea00483c&scoped=true&"
import script from "./QAdetail.vue?vue&type=script&lang=js&"
export * from "./QAdetail.vue?vue&type=script&lang=js&"
import style0 from "./QAdetail.vue?vue&type=style&index=0&id=ea00483c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea00483c",
  null
  
)

export default component.exports